<template>
  <div id="veh-warp">
    <div class="header">车家</div>
    <div class="container">
      <div class="car_show_part">
        <div class="car_img">
          <img :src="currentSku.carImg"/>
        </div>
        <div class="car_data">
          <div class="car_name">
            <img :src="hotIcon"/>
            <p>{{currentSku.carName}}</p>
          </div>
          <div class="car_price_part">
            <p class="car_sell_p">现价: <span>{{currentSku.nowPrice}}</span>元</p>
            <p class="car_price_p">厂商指导价:<span>{{currentSku.guidePrice}}</span>元</p>
          </div>
        </div>
      </div>
      <div class="interval_div"></div>
      <div class="purchasing_plan_part">
        <div class="caption_part">
          <p>购车方案</p>
          <div class="plan_show">
            <div>
              <img src="../assets/image/VehicleInformation/chejia_sell_icon1.png"/>
              <p>首年营运险</p>
            </div>
            <div>
              <img src="../assets/image/VehicleInformation/chejia_sell_icon2.png"/>
              <p>购置税</p>
            </div>
            <div>
              <img src="../assets/image/VehicleInformation/chejia_sell_icon2.png"/>
              <p>营运车牌</p>
            </div>
          </div>
        </div>
        <div class="plan_detail_price">
          <div class="plan_detail_price_left">
            <div>
              <p>首付</p>
            </div>
            <div>
              <p>{{currentSku.downPayment}}</p>
            </div>
          </div>
          <div class="plan_detail_price_mid">
            <div>
              <p>期限</p>
            </div>
            <div>
              <p>{{currentSku.timeLimit}}</p>
            </div>
          </div>
          <div class="plan_detail_price_right">
            <div>
              <p>月供</p>
            </div>
            <div>
              <p>{{currentSku.monthlyInstallment}}</p>
            </div>
          </div>
        </div>
        <div class="notice"><p>以上方案仅为部分城市适用，具体方案请咨询线上销售。</p></div>
      </div>
      <div class="advantage_show_part">
        <div class="caption">
          <p>车家优势</p>
        </div>
        <div class="advantage_show_content">
          <img src="../assets/image/VehicleInformation/chejia_advantage.png"/>
        </div>
      </div>
      <div  class="footer" :class="{'footerActive': isIphoneXFlag }">
        <div class="apply_input_part" v-show="applyShowFlag">
          <div class="mobile_input_part">
            <img src="../assets/image/VehicleInformation/chejia_mobile_icon.png"/>
            <input type="tel" v-model="mobile"/>
          </div>
          <div class="vcode_input_part">
            <img src="../assets/image/VehicleInformation/chejia_vcode_icon.png"/>
            <input type="number" v-model="vCode"/>
            <button @click="getVCode" v-html="vCodeStr"></button>
          </div>
        </div>
        <button @click="advisoryPartShow">我要咨询</button>
      </div>
    </div>
    <div class="mask_layer" v-show="dataInputPartShowFlag" @click="advisoryPartShow"></div>
    <div class="eventBox" :class="{'eventBoxActive':isIphoneXFlag }" v-show="dataInputPartShowFlag">
      <div class="verify_part">
        <div class="item">
          <img src="../assets/image/VehicleInformation/chejia_mobile_icon.png"/>
          <input type="tel" v-model="mobile" placeholder="请输入手机号码" @focus="focusBorderColor" @blur="blurBorderColor" maxlength="11"/>
        </div>
        <div class="item">
          <img src="../assets/image/VehicleInformation/chejia_vcode_icon.png"/>
          <input type="number" v-model="vCode" placeholder="请输入验证码" @focus="focusBorderColor" @blur="blurBorderColor" v-on:input="vCodeMaxLength"/>
          <button @click="getVCode" v-html="vCodeStr"></button>
        </div>
      </div>
      <button @click="submitData">我要咨询</button>
    </div>
  </div>
</template>

<script>
  import hotIcon from '../assets/image/Homepage/chejia_hot.png'
  import carImgEI5 from '../assets/image/VehicleInformation/chejia_car_ei5.png'
  import carImgEX5 from '../assets/image/VehicleInformation/chejia_car_ex5.png'
  import carImgEI6 from '../assets/image/VehicleInformation/chejia_car_ei6.png'
  import { Toast } from 'mint-ui'
  import common from '../utils/common'
  import qs from 'qs';
  export default {
    name: "vehicleInformation",
    data(){
      return {
        inFocus: false,
        isIphoneXFlag: false,
        vehicleInformationType: '',
        carImg: null,
        hotIcon: hotIcon,
        currentSku:  {
          carName: '威马EX5车家出行版',
          sellQuantity: 91,
          guidePrice: 148500,
          downPayment: 13800,
          nowPrice: 115000,
          timeLimit: 36,
          monthlyInstallment: 3840
        },
        skuS:[
          {
            carImg: carImgEX5,
            carName: '威马EX5车家出行版',
            sellQuantity: 91,
            guidePrice: 148500,
            nowPrice: 115000,
            downPayment: 13800,
            timeLimit: 36,
            monthlyInstallment: 3840
          },
          {
            carImg: carImgEI5,
            carName: '荣威 EI5 420KM 豪华版',
            sellQuantity: 126,
            guidePrice: 138800,
            nowPrice: 137800,
            downPayment: 20670,
            timeLimit: 36,
            monthlyInstallment: 4200
          },
          {
            carImg: carImgEI6,
            carName: '荣威 EI6 智享版',
            sellQuantity: 141,
            guidePrice: 201800,
            nowPrice: 146000,
            downPayment: 21900,
            timeLimit: 36,
            monthlyInstallment: 4550
          }
        ],
        applyShowFlag: false,
        mobile: '',
        vCode: '',
        vCodeStr: '获取验证码',
        timeCount: 60,
        dataInputPartShowFlag: false
      }
    },
    mounted(){
      window.scrollTo(0, 0)
      const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      const ratio = window.devicePixelRatio || 1;
      const screen = {
        width : window.screen.width * ratio,
        height : window.screen.height * ratio
      };
      if (iOS && screen.width == 1125 && screen.height === 2436) {
        this.isIphoneXFlag = true
      }

      this.vehicleInformationType = sessionStorage.getItem("type")
      if(this.vehicleInformationType == null || this.vehicleInformationType == ''){
        const router = this.$router
        router.push({
          path: '/',
          name: "Homepage",
          params: {}
        })
      }
      this.currentSku = this.skuS[this.vehicleInformationType]
    },
    methods: {
      // 输入框获取或失去焦点时 底部边框颜色变化
      focusBorderColor(e) {
        e.currentTarget.parentNode.style.border = '0.02rem solid #268fff'
        this.inFocus = true
      },

      blurBorderColor(e) {
        e.currentTarget.parentNode.style.border = '0.02rem solid #cccccc'
        this.inFocus = false
        setTimeout(function () {
          if(!this.inFocus){
            // 当input 失焦时,滚动一下页面就可以使页面恢复正常
            const timer = setInterval(() => {
              let currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
              const speed=1;//页面滚动距离
              currentPosition-=speed;
              window.scrollTo(0, currentPosition)
              clearInterval(timer);
            }, 1)
          }
        },200)
      },
      advisoryPartShow(){
        if(sessionStorage.getItem("mobilePhone")){
          const router = this.$router
          sessionStorage.setItem("infoType", "isSku")
          router.push({
            path: '/successful',
            name: "Successful"
          })
        }
        this.dataInputPartShowFlag = ! this.dataInputPartShowFlag
      },
      // input type='number'时maxlength无效，用此方法限定最大输入长度
      vCodeMaxLength() {
        if (this.vCode != null && this.vCode.length > 6) {
          this.vCode = this.vCode.slice(0, 6)
        }
      },
      getVCode(e){
        let that = e.currentTarget
        that.disabled = true
        this.vCodeStr = '('+ this.timeCount +'s)' + '重新获取'
        this.timer = setInterval( () => {
          this.timeCount--
          if (this.timeCount > 0) {
            this.vCodeStr = '(' + this.timeCount + 's)' + '重新获取'

          } else {
            clearInterval(this.timer); // 清除js定时器
            that.disabled = false;
            this.vCodeStr = '获取验证码';
            this.timeCount = 60; // 重置时间
          }
        }, 1000);
        let data = {"mobile": this.mobile,}
        this.$axios.post('/marketing/getcode', qs.stringify(data)).then(function (res) {
          Toast({
            message: res.data.msg,
            className: 'longMsgStyle'
          })
          return
        }).catch(function (error) {
          Toast({
            message: error.data.msg,
            className: 'longMsgStyle'
          });
          return
        });
      },
      submitData(){
        if(common.trimAll(this.mobile) == null){
          Toast({
            message: "请输入手机号码",
            className: 'longMsgStyle'
          })
          return
        }else{
          if(!common.checkMobile(this.mobile)){
            Toast({
              message: "手机号码格式不正确",
              className: 'longMsgStyle'
            })
            return
          }
        }
        if(common.trimAll(this.vCode) == null){
          Toast({
            message: "请输入验证码",
            className: 'longMsgStyle'
          })
          return
        }else{
          if(common.trimAll(this.vCode).length != 6){
            Toast({
              message: "请输入6位数字验证码",
              className: 'longMsgStyle'
            })
            return
          }
        }
        const router = this.$router
        const that = this
        let data = {"mobile": that.mobile,
            "code": that.vCode,
            "carModel": that.currentSku.carName}
        that.$axios.post('/marketing/checkcode', qs.stringify(data)).then(function (res) {
          that.advisoryPartShow()
          sessionStorage.setItem("infoType", "isSku")
          sessionStorage.setItem("mobilePhone", that.mobile)
          if(res.data.data == null){
            sessionStorage.setItem("userId",  '')
          }else{
            sessionStorage.setItem("userId",  res.data.data)
          }
          router.push({
            path: '/successful',
            name: "Successful"
          })
        }).catch(function (error) {
          Toast({
            message: error.data.msg,
            className: 'longMsgStyle'
          })
          return
        });
      }
    }
  }
</script>

<style scoped>
  .longMsgStyle{
    margin: 0 auto;
    width: 60%;
    left: 0!important;
    right: 0!important;
    transform: translate(-0%, -50%)!important;
  }
  html {
    background-color: #fff;
  }
  #veh-warp{
    width: 100vw;
    padding-bottom: 2.68rem;
  }

  #veh-warp > .header{
    width: 100%;
    height: 0.98rem;
    line-height: 0.98rem;
    background-color: #fff;
    color: #222;
    font-size: 0.36rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    text-align: center;
  }

  #veh-warp > .container {
    margin: 0 auto;
    width: 7.5rem;
  }
  #veh-warp > .container > .car_show_part{
    width: 100%;
    padding-bottom: 0.37rem;
  }
  .container > .car_show_part > .car_img{
    margin: 0 auto;
    width: 6.7rem;
    font-size: 0;
  }
  .container > .car_show_part > .car_img > img {
    width: 100%;
  }
  .container > .car_show_part > .car_data{
    margin: 0 auto;
    width: 6.7rem;
  }
  .car_show_part > .car_data > .car_name{
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: baseline;
    font-size: 0;
  }
  .car_show_part > .car_data > .car_name > img{
    width: 0.27rem;
    height: 0.31rem;
  }
  .car_show_part > .car_data > .car_name > p{
    margin: 0;
    padding: 0;
    margin-left: 0.17rem;
    font-size: 0.36rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.36rem;
    color: #666666;
  }
  .car_show_part > .car_data > .car_price_part {
    margin: 0 auto;
    margin-top: 0.17rem;
    width: 6.7rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }
  .car_show_part > .car_data > .car_price_part > p {
    padding: 0;
    margin: 0;
    line-height: 0.28rem;
    font-size: 0.22rem;
    font-weight: normal;
    font-stretch: normal;
    color: #666666;
  }
  .car_show_part > .car_data > .car_price_part > p > span {
    margin-left: 0.1rem;
  }
  .car_show_part > .car_data > .car_price_part > p:last-child > span {
    text-decoration:line-through;
  }
  .car_show_part > .car_data > .car_price_part > p:first-child{
    margin-left: 0.44rem;
  }
  .car_show_part > .car_data > .car_price_part > p:first-child{
    font-size: 0.28rem;
    color: #222;
    margin-right: 0.18rem;
  }
  .interval_div {
    margin-left: 0.4rem;
    width: 7.10rem;
    height: 0.2rem;
    background-color: #eeeeee;
    opacity: 0.49;
  }
  .purchasing_plan_part{
    margin: 0 auto;
    margin-top: 0.37rem;
    width: 6.7rem;
  }
  .purchasing_plan_part > .caption_part{
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }
  .purchasing_plan_part > .caption_part > p {
    margin: 0;
    padding: 0;
    font-size: 0.28rem;
    font-weight: bold;
    font-stretch: normal;
    letter-spacing: 0.011rem;
    color: #222222;
  }
  .purchasing_plan_part > .caption_part > .plan_show{
    margin-right: 0.18rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }
  .purchasing_plan_part > .caption_part > .plan_show >  div {
    font-size: 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }
  .purchasing_plan_part > .caption_part > .plan_show >  div:nth-child(2) {
    margin: 0 0.2rem;
  }
  .purchasing_plan_part > .caption_part > .plan_show >  div > img {
    width: 0.25rem;
    height: 0.25rem;
  }
  .purchasing_plan_part > .caption_part > .plan_show >  div > p {
    margin: 0;
    padding: 0;
    margin-left: 0.04rem;
    font-size: 0.22rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0.01rem;
    color: #222222;
  }
  .purchasing_plan_part > .plan_detail_price{
    margin: 0 auto;
    margin-top: 0.36rem;
    padding-top: 0.23rem;
    padding-bottom: 0.25rem;
    width: 6.7rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-around;
    background-color: #2a9ef0;
  }
  .plan_detail_price > div > div {
    min-width: 1.5rem;
    text-align: center;
  }
  .plan_detail_price_left > div:first-child > p,
  .plan_detail_price_mid > div:first-child > p,
  .plan_detail_price_right > div:first-child > p{
    margin: 0;
    padding: 0;
    font-size: 0.24rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0.01rem;
    color: #ffffff;
  }
  .plan_detail_price_left > div:last-child > p,
  .plan_detail_price_mid > div:last-child > p,
  .plan_detail_price_right > div:last-child > p{
    margin: 0;
    padding: 0;
    margin-top: 0.2rem;
    font-size: 0.32rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0.013rem;
    color: #ffffff;
    text-align: center;
  }
  .notice{
    width: 6.7rem;
    margin-top: 0.22rem;
    font-size: 0.22rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0.01rem;
    color: #666666;
    text-align: center;
  }
  .notice > p{
    margin: 0;
    padding: 0;
  }
  .advantage_show_part{
    margin: 0 auto;
    margin-top: 0.49rem;
    width: 6.7rem;
  }
  .advantage_show_part > .caption {
    font-size: 0.28rem;
    font-weight: bold;
    font-stretch: normal;
    letter-spacing: 0.011rem;
    color: #222222;
  }
  .advantage_show_part > .caption > p {
    margin: 0;
    padding: 0;
  }
  .advantage_show_part > .advantage_show_content{
    margin-top: 0.37rem ;
    font-size: 0;
    width: 100%;
  }
  .advantage_show_part > .advantage_show_content > img{
    width: 100%;
  }
  #veh-warp .footer{
    padding-bottom: 0.4rem;
    padding-top: 0.28rem;
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: #fff;
    z-index: 10;
  }

  #veh-warp .footerActive{
    padding-bottom: 1.2rem;
  }
  #veh-warp .footer > button {
    border-width: 0;
    margin: 0;
    padding: 0;
    display: block;
    box-shadow: none;
    width: 6.86rem;
    height: 0.92rem;
    font-size: 0.36rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #fefefe;
    outline: none;
    background-image: linear-gradient(-90deg,
    #2694ff 0%,
    #42da94 100%),
    linear-gradient(
      #3547c7,
      #3547c7);
    background-blend-mode: normal,
    normal;
    border-radius: 0.12rem;
  }
  .mask_layer{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #222!important;
    opacity: .3;
    z-index: 9;
  }
  .eventBox{
    padding-bottom: 0.5rem;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
  }
  .eventBoxActive{
    padding-bottom: 1rem;
  }
  .verify_part {
    margin: 0 auto;
    padding-top: 0.36rem;
    width: 6.98rem;
  }
  .verify_part .item{
    /*border: 1px solid #268fff;*/
    border: 1px solid #cccccc;
    position: relative;
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    font-size: 0;
    border-radius: 0.12rem;
    overflow: hidden;
  }
  .verify_part > .item > img {
    position: absolute;
    top: 35%;
    left: 0.32rem;
  }
  .verify_part > .item:first-child > img {
    width: 0.27rem;
    height: 0.38rem;
  }
  .verify_part > .item:last-child {
    margin-top: 0.26rem;
  }
  .verify_part > .item:last-child > img {
    width: 0.30rem;
    height: 0.36rem;
  }
  .verify_part > .item > input {
    margin: 0;
    padding: 0;
    border-radius: 0.12rem;
    padding-left: 0.84rem;
    padding-right: 2.5rem;
    display: block;
    width: 4.98rem;
    height: 0.92rem;
    line-height: 0.32rem;
    border-width: 0;
    outline: none;
  }
  .verify_part > .item:last-child > button {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 0;
    margin: 0;
    padding-right: 0.32rem;
    display: block;
    box-shadow: none;
    border-width: 0;
    background-color: #fff;
    letter-spacing: 0.01rem;
    color: #268fff;
  }
  .eventBox > button {
    border-width: 0;
    margin: 0;
    padding: 0;
    margin: 0 auto;
    margin-top: 0.4rem;
    display: block;
    box-shadow: none;
    width: 6.86rem;
    height: 0.92rem;
    font-size: 0.36rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #fefefe;
    outline: none;
    background-image: linear-gradient(-90deg,
    #2694ff 0%,
    #42da94 100%),
    linear-gradient(
      #3547c7,
      #3547c7);
    background-blend-mode: normal,
    normal;
    border-radius: 0.12rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/VehicleInformation.vue